<template>
  <div class="coupon-container">
    <div class="usercenter-title">
      <h4>我的优惠券</h4>
    </div>
    <div class="mod-form">
      <a-form :form="form" layout="inline" @submit="handleSubmit">
        <a-form-item label="我的优惠券号">
          <a-input v-model.trim="couponNo" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">
            激活
          </a-button>
        </a-form-item>
        <a-form-item v-if="agreeList.length">
          <AgreementTrack
           :checked="couponAgreement"
           :cmsId="agreeListModuleId"
           description='优惠券列表页（激活）'
           pageName='venus_coupon_active'
           @change="e => couponAgreement = e">
            我已阅读并同意
            <template v-for="(item, index) in agreeList">
              <router-link :to="item.url" :key="index" target="_blank">{{ item.name }}{{ index === (agreeList.length - 1) ? '' : '，'}}</router-link>
            </template>
          </AgreementTrack>
        </a-form-item>
      </a-form>
    </div>
    <div class="coupon-body">
      <a-tabs :default-active-key="activeKey" @change="onTab">
        <a-tab-pane key="UNUSED" tab="未使用">
          <use-table
            :loading="loading"
            :data="data"
            @change="onUseTableChange"
            ref="useTable"
          ></use-table>
        </a-tab-pane>
        <a-tab-pane key="USED" tab="已使用">
          <used-table
            :loading="loading"
            :data="data"
            @change="onUsedTableChange"
            @detail="onShowDetail"
          ></used-table>
        </a-tab-pane>
        <a-tab-pane key="EXPIRED" tab="已过期">
          <expired-table
            :loading="loading"
            :data="data"
            @change="onExpiredTableChange"
            @detail="onShowDetail"
          ></expired-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <a-modal
      title="优惠券详情"
      :visible="visible"
      width="640px"
      @cancel="visible = false"
    >
      <template slot="footer">
        <a-button type="primary" @click="visible = false">
          确认
        </a-button>
      </template>
      <div class="mod-coupon-detail">
        <table>
          <colgroup>
            <col>
            <col>
            <col>
            <col>
            <col>
          </colgroup>
          <tbody>
            <tr>
              <td colspan="1">优惠券号</td>
              <td colspan="1">优惠券类型</td>
              <td colspan="1">使用平台</td>
              <td colspan="1">面额</td>
              <td colspan="1">使用限额</td>
              <td colspan="1">实名使用券</td>
            </tr>
            <tr>
              <td colspan="1">{{ couponDetail.couponNumber }}</td>
              <td colspan="1">{{ couponDetail.couponType | couponType }}</td>
              <td colspan="1">{{ couponDetail.usePlatform | usePlatform }}</td>
              <td colspan="1">{{ couponDetail.couponAmount }}元</td>
              <td colspan="1">{{ couponDetail.couponQuata }}元（含以上）</td>
              <td colspan="1">{{ couponDetail.couponUseType === 'REALNAME' ? '是' : '否' }}</td>
            </tr>
            <tr>
              <td colspan="3">适用航班日期</td>
              <td colspan="3">优惠券有效期</td>
            </tr>
            <tr>
              <td colspan="3">{{ couponDetail.applyFltDates | applyFltDates }}</td>
              <td colspan="3">{{ couponDetail.validity }}</td>
            </tr>
            <tr>
              <td colspan="3">适用航班</td>
              <td colspan="3">不适用航班</td>
            </tr>
            <tr>
              <td colspan="3">{{ couponDetail.flightNo || '-'  }}</td>
              <td colspan="3">{{ couponDetail.disabledFlightNo || '-' }}</td>
            </tr>
            <tr>
              <td colspan="3">适用产品</td>
              <td colspan="3">适用航线种类</td>
            </tr>
            <tr>
              <td colspan="3">{{ getAllowDetail(couponDetail.allowFltProudcts,"productName")  || '-' }}</td>
              <td colspan="3">{{ getAllowDetail(couponDetail.allowFltType,"flightName")  || '-' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="tip">
          <h6>用券须知：</h6>
          <div v-html="returnTips(couponDetail.couponType)"></div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { activeMyCoupon, myCoupon } from '@/apis/coupon'
import useTable from './components/useTable'
import usedTable from './components/usedTable'
import expiredTable from './components/expiredTable'
import AgreementTrack from '@/components/agreement-track'
import { userTypeMap } from '@/dicts/member'
import './index'

const airline = window.__MICRO_ROOT__?.airline || ''

export default {
  data () {
    return {
      data: {
        list: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        }
      },
      couponNo: '',
      couponAgreement: false,
      loading: false,
      visible: false,
      couponDetail: {},
      activeKey: 'UNUSED',
      couponCmsData: {},
      agreeList: [],
      agreeListModuleId: ''
    }
  },
  beforeCreate () {
    const user = window.__MICRO_ROOT__.user?.get()
    this.form = this.$form.createForm(this, { name: 'register' })

    if (userTypeMap[user.userType] === 'CARRIER' || userTypeMap[user.userType] === 'AGENT' || user.loginName === 'ETMOBILEUSER') {
      this.$modal.warning({
        title: '提示',
        content: '当前用户类型无法使用优惠券',
        okText: '确认',
        onOk: () => { this.$router.replace({ path: '/order/v2/search' }) }
      })
    }
  },
  mounted () {
    this.getCmsData()
    this.search({
      couponStatus: 'UNUSED',
      couponType: 'TICKET',
      current: 1,
      pageSize: 12
    })
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          this.couponCmsData = res || {}
          this.agreeList = res?.['usercoupon-agree']?.list || []
          this.agreeListModuleId = res?.['usercoupon-agree']?._moduleId || ''
        })
      } catch (err) {}
    },
    returnTips (couponType = '') {
      const couponTypeObj = this.couponCmsData[`usercoupon-${couponType.toLocaleLowerCase()}`]
      const content = couponTypeObj?.content || ''

      return content
    },
    async handleSubmit (e) {
      e && e.preventDefault()
      const { couponNo, couponAgreement, agreeList } = this

      if (!couponNo) {
        this.$message.error('请输入优惠券号！')
        return
      }

      if (agreeList.length && !couponAgreement) {
        const agreeMentTitleGroup = agreeList?.map(item => { return item.name })?.join(',')
        this.$message.error(`请阅读并同意${agreeMentTitleGroup}！`)
        return
      }

      try {
        await activeMyCoupon({
          couponNumber: couponNo,
          airlineCode: airline
        })

        this.$message.success('激活成功')
        this.search({
          couponStatus: this.activeKey,
          couponType: this.$refs.useTable.type,
          current: 1,
          pageSize: 12
        })
      } catch (err) {
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },
    async search (params) {
      this.loading = true

      params.page = params.current
      delete params.current

      try {
        const data = await myCoupon({
          ...params,
          airlineCode: airline
        })

        this.loading = false
        const { content = [], page = 1, pageSize, total = 0 } = data
        this.data = {
          list: content || [],
          pagination: {
            current: page,
            pageSize,
            total
          }
        }
      } catch (err) {
        this.loading = false
        this.data = {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },
    onUseTableChange (type, pagination) {
      this.couponType = type
      this.search({
        couponType: type,
        couponStatus: 'UNUSED',
        ...pagination
      })
    },
    onUsedTableChange (pagination) {
      this.search({
        couponStatus: 'USED',
        ...pagination
      })
    },
    onExpiredTableChange (pagination) {
      this.search({
        couponStatus: 'EXPIRED',
        ...pagination
      })
    },
    onTab (key) {
      this.activeKey = key
      const params = {
        couponStatus: key,
        current: 1,
        pageSize: 10
      }

      if (key === 'UNUSED') {
        params.couponType = 'TICKET'
        params.pageSize = 12
      }

      this.search(params)
    },
    onShowDetail (coupon) {
      if (coupon) {
        this.couponDetail = coupon
        this.visible = true
      }
    }
  },
  computed: {
    getAllowDetail () {
      return function (value, type) {
        return value ? value.map(item => { return item[type] }).join(',') : ''
      }
    }
  },
  components: {
    useTable,
    usedTable,
    expiredTable,
    AgreementTrack
  }
}
</script>
